
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ApiService } from '@libs/unified-ui-framework/src/shared/api-service';
import store, { RootStoreState } from '@/store';
import { ExchangeAccessCodeResponse } from '@/modules/sw-ftr-bill-meter/types';

@Component
export default class SwRmApiMixin extends Vue {
  error = false;

  @State((state: RootStoreState) => (state.CoreStoreModule.token))
  token: number | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.code))
  code: number | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.exchangeAccessCode))
  exchangeAccessCode: boolean;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenantid))
  tenantid: string | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;

  @State((state: RootStoreState) => (state.CoreStoreModule.username))
  username: string | undefined;
  thirdPartyDetails: any = [];
  processApi(refresh: boolean, cb?: () => void) {
    const apiService = new ApiService('');
    // let thirdPartyDetails = [];
    if (this.exchangeAccessCode) {
      Promise.all([apiService.post(`/api/exchange-cscAccessCode?accessCode=${this.code}`, 1)])
      .then((_) => {
        const res = _[0] as ExchangeAccessCodeResponse;

        if (res.operationStatus === 'OK') {
          const weightsAPICall = apiService.get<any>('/api/weights');
          const sscv2APICall = apiService.get<any>('/api/SSCV2?date=180918');
          const mysonicwallAPICall = apiService.get<any>(`/api/mysonicwall?productgroupid=${this.tenantid}&` +
                                                                    `username=${this.username}&` +
                                                                    // tslint:disable-next-line:max-line-length
                                                                    `bearer=${res.content.token}&` +
                                                                    // tslint:disable-next-line:max-line-length
                                                                    // 'bearer=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOiIxNjg5MzcyODY0IiwiaXNzIjoiaHR0cHM6Ly9teS5teXNvbmljd2FsbC5jb20vT0F1dGgyMCIsImF1ZCI6Imh0dHBzOi8vd3d3Lm15c29uaWN3YWxsLmNvbS9PQXV0aDIiLCJzSWQiOiJBRUFBREM0MS04RDUxLTQ0MDktQjdCRC0zN0VBQ0RDMDJDMkMiLCJ1c2VyTmFtZSI6IjRfMjY1NTkxMzciLCJsb2NhbGVOYW1lIjoiRU4iLCJjbGllbnRJZCI6IlJNMDI0NTMzIiwiZW1haWwiOiJzY2hhbmdAc29uaWN3YWxsLmNvbSIsImdpdmVuTmFtZSI6IlNoYXJvbiBDaGFuZyIsIm9yZ2lkIjoiOTExMDkzIiwiaXNBRiI6Ik5PIiwicHN1cCI6Ik5PIiwic2VsZiI6IjAiLCJyb2xlcyI6IkNVU1RPTUVSLFN1cHBvcnRVc2VyLEZMRVhTUEVORCxTUEEsTkZSLEJldGFQcm9ncmFtLFNQT0dVU0VSLFNQT0dDQVMsV09SS1NQQUNFQkVUQSxTUE9HU1NDIiwidElkIjoiMjA0OTc4MSIsImFjY2Vzc0NvdW50ZXJJZCI6IjQ0NzM4IiwicENsaWQiOiJHTVNCNUM2NEYxU1BPRyIsImNvbXBhbnlOYW1lIjoiU29uaWNXQUxMIiwiY291bnRyeUNvZGUiOiJVUyIsInBhcnRuZXJUaWVyIjoiIn0.ZSLs-NI8i-h41LvFLKntUDe89x1-Jj_Wr9VhvPlIz6w' + '&' +
                                                                    `refresh=${refresh}`);
          const rotationsAPICall = apiService.get<any>('/api/rotations');
          if (res && res.content && res.content.token) {
            store.commit('setToken', { token: res.content.token });
            // tslint:disable-next-line:max-line-length
            // store.commit('setToken', { token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOiIxNjg5MzcyODY0IiwiaXNzIjoiaHR0cHM6Ly9teS5teXNvbmljd2FsbC5jb20vT0F1dGgyMCIsImF1ZCI6Imh0dHBzOi8vd3d3Lm15c29uaWN3YWxsLmNvbS9PQXV0aDIiLCJzSWQiOiJBRUFBREM0MS04RDUxLTQ0MDktQjdCRC0zN0VBQ0RDMDJDMkMiLCJ1c2VyTmFtZSI6IjRfMjY1NTkxMzciLCJsb2NhbGVOYW1lIjoiRU4iLCJjbGllbnRJZCI6IlJNMDI0NTMzIiwiZW1haWwiOiJzY2hhbmdAc29uaWN3YWxsLmNvbSIsImdpdmVuTmFtZSI6IlNoYXJvbiBDaGFuZyIsIm9yZ2lkIjoiOTExMDkzIiwiaXNBRiI6Ik5PIiwicHN1cCI6Ik5PIiwic2VsZiI6IjAiLCJyb2xlcyI6IkNVU1RPTUVSLFN1cHBvcnRVc2VyLEZMRVhTUEVORCxTUEEsTkZSLEJldGFQcm9ncmFtLFNQT0dVU0VSLFNQT0dDQVMsV09SS1NQQUNFQkVUQSxTUE9HU1NDIiwidElkIjoiMjA0OTc4MSIsImFjY2Vzc0NvdW50ZXJJZCI6IjQ0NzM4IiwicENsaWQiOiJHTVNCNUM2NEYxU1BPRyIsImNvbXBhbnlOYW1lIjoiU29uaWNXQUxMIiwiY291bnRyeUNvZGUiOiJVUyIsInBhcnRuZXJUaWVyIjoiIn0.ZSLs-NI8i-h41LvFLKntUDe89x1-Jj_Wr9VhvPlIz6w' });
          }
          console.log(res.content.token);
          Promise.all([weightsAPICall, sscv2APICall, mysonicwallAPICall, rotationsAPICall])
          .then((_) => {
            store.commit('setWeights', { weights: _[0].weights.data });
            store.commit('setSSCV2', { SSCV2: _[1].SSCV2.data });
            store.commit('setMysonicwall', { mysonicwall: _[2].msw });
            // _[2].threats[4].tenants['1847052'] = {
            //   count: 15,
            // };
            store.commit('setConsolidatedThreats', { consolidatedThreats: _[2].threats });
            store.commit('setRotations', { rotations: _[3].rotations });

            if (_[2] && _[2].msw && _[2].msw.error && _[2].msw.error === true) {
              this.error = true;
            } else {
              this.error = false;
            }
            store.commit('setBmError', { bmError: this.error });
            const tenantGroups = this.groupRowsByThing(_[2].msw.content.rows, 'tenantName')
                                      .map((_:any) => {
                                        return { id: _.tenantId, label: _.name, value: _.tenantId };
                                      });

            store.commit('setBillmeterloading', { billmeterloading: false });
            tenantGroups.sort((a, b) => a.label.charCodeAt(0) - b.label.charCodeAt(0));
            store.commit('setTenants', { tenants: tenantGroups });
            // if (refresh) {
            //   store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
            // }
            tenantGroups.forEach((tenant: any) => {
              // Object.assign(this.thirdPartyDetails[0], { id: tenant.id });
              const filteredData = this.thirdPartyDetails.filter((item: any) => {
                return item.id === tenant.id;
              });
              if (filteredData === undefined || filteredData.length === 0) {
                this.thirdPartyDetails.push({ id: tenant.id });
              }
              this.getThirdPartyData(tenant.id);
            });
            // console.log(this.tenantid);
            const tenantIndex = tenantGroups.findIndex(tenantGrp => tenantGrp.id === this.selectedTenantId);
            if (tenantIndex > 0) {
              store.commit('setSelectedTenantId', { selectedTenantId: this.selectedTenantId });
            } else {
              store.commit('setSelectedTenantId', { selectedTenantId: tenantGroups.length > 0 ? tenantGroups[0].id : '' });
            }
            // console.log(_[2].msw.content.rows.map((_:any) => _.tenantId));
            //  console.log(_[2].msw.content.rows.filter((_:any) => _.tenantId === '1847052' && ));
            // console.log(tenantGroups.map(_ => _.id));
            if (cb) {
              cb();
            }
          });
        } else {
          this.processRmApiRequest(refresh, cb);
        }
      });
    } else {
      this.processRmApiRequest(refresh, cb);
    }
  }

  processRmApiRequest(refresh: boolean, cb?: () => void) {
    const apiService = new ApiService('');
    const weightsAPICall = apiService.get<any>('/api/weights');
    const sscv2APICall = apiService.get<any>('/api/SSCV2?date=180918');
    const mysonicwallAPICall = apiService.get<any>(`/api/mysonicwall?productgroupid=${this.tenantid}&` +
                                                                    `username=${this.username}&` +
                                                                    // tslint:disable-next-line:max-line-length
                                                                    `bearer=${this.token}&` +
                                                                    // tslint:disable-next-line:max-line-length
                                                                    // 'bearer=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOiIxNjg5MzcyODY0IiwiaXNzIjoiaHR0cHM6Ly9teS5teXNvbmljd2FsbC5jb20vT0F1dGgyMCIsImF1ZCI6Imh0dHBzOi8vd3d3Lm15c29uaWN3YWxsLmNvbS9PQXV0aDIiLCJzSWQiOiJBRUFBREM0MS04RDUxLTQ0MDktQjdCRC0zN0VBQ0RDMDJDMkMiLCJ1c2VyTmFtZSI6IjRfMjY1NTkxMzciLCJsb2NhbGVOYW1lIjoiRU4iLCJjbGllbnRJZCI6IlJNMDI0NTMzIiwiZW1haWwiOiJzY2hhbmdAc29uaWN3YWxsLmNvbSIsImdpdmVuTmFtZSI6IlNoYXJvbiBDaGFuZyIsIm9yZ2lkIjoiOTExMDkzIiwiaXNBRiI6Ik5PIiwicHN1cCI6Ik5PIiwic2VsZiI6IjAiLCJyb2xlcyI6IkNVU1RPTUVSLFN1cHBvcnRVc2VyLEZMRVhTUEVORCxTUEEsTkZSLEJldGFQcm9ncmFtLFNQT0dVU0VSLFNQT0dDQVMsV09SS1NQQUNFQkVUQSxTUE9HU1NDIiwidElkIjoiMjA0OTc4MSIsImFjY2Vzc0NvdW50ZXJJZCI6IjQ0NzM4IiwicENsaWQiOiJHTVNCNUM2NEYxU1BPRyIsImNvbXBhbnlOYW1lIjoiU29uaWNXQUxMIiwiY291bnRyeUNvZGUiOiJVUyIsInBhcnRuZXJUaWVyIjoiIn0.ZSLs-NI8i-h41LvFLKntUDe89x1-Jj_Wr9VhvPlIz6w' + '&' +
                                                                    `refresh=${refresh}`);
    const rotationsAPICall = apiService.get<any>('/api/rotations');
    // tslint:disable-next-line:max-line-length
    // store.commit('setToken', { token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOiIxNjg5MzcyODY0IiwiaXNzIjoiaHR0cHM6Ly9teS5teXNvbmljd2FsbC5jb20vT0F1dGgyMCIsImF1ZCI6Imh0dHBzOi8vd3d3Lm15c29uaWN3YWxsLmNvbS9PQXV0aDIiLCJzSWQiOiJBRUFBREM0MS04RDUxLTQ0MDktQjdCRC0zN0VBQ0RDMDJDMkMiLCJ1c2VyTmFtZSI6IjRfMjY1NTkxMzciLCJsb2NhbGVOYW1lIjoiRU4iLCJjbGllbnRJZCI6IlJNMDI0NTMzIiwiZW1haWwiOiJzY2hhbmdAc29uaWN3YWxsLmNvbSIsImdpdmVuTmFtZSI6IlNoYXJvbiBDaGFuZyIsIm9yZ2lkIjoiOTExMDkzIiwiaXNBRiI6Ik5PIiwicHN1cCI6Ik5PIiwic2VsZiI6IjAiLCJyb2xlcyI6IkNVU1RPTUVSLFN1cHBvcnRVc2VyLEZMRVhTUEVORCxTUEEsTkZSLEJldGFQcm9ncmFtLFNQT0dVU0VSLFNQT0dDQVMsV09SS1NQQUNFQkVUQSxTUE9HU1NDIiwidElkIjoiMjA0OTc4MSIsImFjY2Vzc0NvdW50ZXJJZCI6IjQ0NzM4IiwicENsaWQiOiJHTVNCNUM2NEYxU1BPRyIsImNvbXBhbnlOYW1lIjoiU29uaWNXQUxMIiwiY291bnRyeUNvZGUiOiJVUyIsInBhcnRuZXJUaWVyIjoiIn0.ZSLs-NI8i-h41LvFLKntUDe89x1-Jj_Wr9VhvPlIz6w' });
    store.commit('setBillmeterloading', { billmeterloading: true });
    Promise.all([weightsAPICall, sscv2APICall, mysonicwallAPICall, rotationsAPICall])
    .then((_) => {
      store.commit('setWeights', { weights: _[0].weights.data });
      store.commit('setSSCV2', { SSCV2: _[1].SSCV2.data });
      store.commit('setMysonicwall', { mysonicwall: _[2].msw });
      const tenantsWaf = {
        // 1847052: {
        //   count: 0,
        // },
      };
      _[2].threats[4] = {
        tenants: tenantsWaf,
      };
      store.commit('setConsolidatedThreats', { consolidatedThreats: _[2].threats });
      store.commit('setRotations', { rotations: _[3].rotations });

      if (_[2] && _[2].msw && _[2].msw.error && _[2].msw.error === true) {
        this.error = true;
      } else {
        this.error = false;
      }
      store.commit('setBmError', { bmError: this.error });
      const tenantGroups = this.groupRowsByThing(_[2].msw.content.rows, 'tenantName')
                                .map((_:any) => {
                                  return { id: _.tenantId, label: _.name, value: _.tenantId };
                                });

      store.commit('setBillmeterloading', { billmeterloading: false });
      tenantGroups.sort((a, b) => a.label.charCodeAt(0) - b.label.charCodeAt(0));
      store.commit('setTenants', { tenants: tenantGroups });
      // if (refresh) {
      //   store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
      // }
      tenantGroups.forEach((tenant: any) => {
        // Object.assign(this.thirdPartyDetails[0], { id: tenant.id });
        const filteredData = this.thirdPartyDetails.filter((item: any) => {
          return item.id === tenant.id;
        });
        if (filteredData === undefined || filteredData.length === 0) {
          this.thirdPartyDetails.push({ id: tenant.id });
        }
        this.getThirdPartyData(tenant.id);
      });
      const tenantIndex = tenantGroups.findIndex(tenantGrp => tenantGrp.id === this.selectedTenantId);
      if (tenantIndex > 0) {
        store.commit('setSelectedTenantId', { selectedTenantId: this.selectedTenantId });
      } else {
        store.commit('setSelectedTenantId', { selectedTenantId: tenantGroups.length > 0 ? tenantGroups[0].id : '' });
      }
      if (cb) {
        cb();
      }
    });
  }

  groupRowsByThing(rows:any, thing:any) {
    const tenantGroupsObject:any = {};
    if (rows && rows.length > 0) {
      rows.forEach((row:any) => {
        if (row[thing]) {     //// DATECHECK
          if (row[thing] in tenantGroupsObject) {
            tenantGroupsObject[row[thing]].rows.push(row);
          } else {
            tenantGroupsObject[row[thing]] = {
              rows: [row],
            };
          }
          if (!tenantGroupsObject[row[thing]]['tenantId']) {
            tenantGroupsObject[row[thing]]['tenantId'] = row['tenantId'];
          }
        }
      });
    }

    const tenantGroups = [];
    for (const key in tenantGroupsObject) {
      tenantGroups.push({
        name: key,
        tenantId: tenantGroupsObject[key]['tenantId'],
        rows: tenantGroupsObject[key].rows,
      });
    }
    return tenantGroups;
  }

  getThirdPartyData(tenantId: string, cb?: () => void) {
    const apiService = new ApiService('');
    const threats = ['waf', 'email', 'cloud', 'nextgenav', 'firewall'];
    threats.forEach((val) => {
      const response = apiService
      .get<any>(`/api/thirdpartydata?productgroupid=${tenantId}&username=${this.username}&bearer=${this.token}&threatType=${val}`);
      Promise.all([response])
      .then((_) => {
        // console.log(`---Data---${JSON.stringify(_[0].data)}`);
        // const tenantData = {
        //   tenantId: tenantId,
        //   waf: val === 'waf' ? _[0].data : '',
        //   firewall: val === 'firewall' ? _[0].data : '',
        //   nextgenav: val === 'nextgenav' ? _[0].data : '',
        //   email: val === 'email' ? _[0].data : '',
        //   cloud: val === 'cloud' ? _[0].data : '',
        // };
        // const temp = this.thirdPartyDetails.filter((item: any) => {
        //   return item.id === tenantId;
        // });
        // let copyVal = {};
        if (val === 'waf') {
          this.thirdPartyDetails.forEach((t: any) => {
            if (t.id === tenantId) {
              t['waf'] = _[0].data;
            }
          });
          // temp[0].waf =  _[0].data;
          // copyVal = Object.assign(this.thirdPartyDetails, temp);
          store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
          console.log(store.state.CoreStoreModule.thirdParty);
        } else if (val === 'email') {
          // store.commit('setEmail', { email: response });
          this.thirdPartyDetails.forEach((t: any) => {
            if (t.id === tenantId) {
              t['email'] = _[0].data;
            }
          });
          store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
          console.log(store.state.CoreStoreModule.thirdParty);
        } else if (val === 'cloud') {
          // store.commit('setCloud', { cloud: response });
          this.thirdPartyDetails.forEach((t: any) => {
            if (t.id === tenantId) {
              t['cloud'] = _[0].data;
            }
          });
          store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
          console.log(store.state.CoreStoreModule.thirdParty);
        } else if (val === 'nextgenav') {
          // store.commit('setNextGenAV', { nextgenav: response });
          this.thirdPartyDetails.forEach((t: any) => {
            if (t.id === tenantId) {
              t['nextgenav'] = _[0].data;
            }
          });
          store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
          console.log(store.state.CoreStoreModule.thirdParty);
        } else if (val === 'firewall') {
          // store.commit('setFirewall', { firewall: response });
          this.thirdPartyDetails.forEach((t: any) => {
            if (t.id === tenantId) {
              t['firewall'] = _[0].data;
            }
          });
          store.commit('setThirdParty', { thirdParty: this.thirdPartyDetails });
          console.log(store.state.CoreStoreModule.thirdParty);
        }

        // Object.assign(thirdPartyDetails, );
        // store.commit('setThirdParty', { thirdParty: _[0].data });
        if (cb) {
          cb();
        }
      });
    });
  }

  saveThirdPartyData(value: string, threatType: string) {
    const apiService = new ApiService('');
    apiService.post<any>(`/api/thirdpartydata?productgroupid=${this.selectedTenantId}&username=${this.username}&bearer=${this.token}&threatType=${threatType}` +
    `&value=${value}`,
                         1);
  }

}
